export const inputCls = "h-12 w-full rounded-lg border border-slate-300 bg-white px-3.5 text-slate-900 outline-none transition-colors focus:border-amber-500 focus:ring-2 focus:ring-amber-200";
export const areaCls = "w-full rounded-lg border border-slate-300 bg-white p-3.5 text-slate-900 outline-none transition-colors focus:border-amber-500 focus:ring-2 focus:ring-amber-200";
export const btnPrimary = "inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-slate-900 px-5 font-bold text-white transition-colors hover:bg-slate-800 disabled:opacity-60";
export const btnGhost = "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-100 disabled:opacity-60";

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-semibold text-slate-700">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-slate-400">{hint}</span>}
  </label>
);

export const Select = ({ options, testid, ...p }) => (
  <select data-testid={testid} className={inputCls} {...p}>
    {Object.entries(options).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
  </select>
);

export const Segmented = ({ options, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-2" data-testid={testid}>
    {Object.entries(options).map(([k, v]) => (
      <button type="button" key={k} data-testid={`${testid}-${k}`} onClick={() => onChange(k)}
        className={`h-12 rounded-lg border px-4 text-sm font-bold transition-colors ${value === k ? "border-slate-900 bg-slate-900 text-white" : "border-slate-300 bg-white text-slate-700 hover:border-slate-400"}`}>
        {v}
      </button>
    ))}
  </div>
);
